import React from 'react';

const Choose = () => {
    return (
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.59957 0.293584L9.9007 2.19665C10.2343 2.38957 10.5113 2.66667 10.7043 3.00025C10.8972 3.33384 10.9992 3.71222 11 4.09758V7.90158C10.9994 8.28727 10.8975 8.66603 10.7046 9C10.5117 9.33397 10.2345 9.61143 9.9007 9.80465L6.59957 11.7072C6.26535 11.899 5.88671 12 5.50134 12C5.11597 12 4.73733 11.899 4.40311 11.7072L1.0993 9.80465C0.765849 9.61161 0.488849 9.33449 0.295953 9.00093C0.103057 8.66737 0.00101122 8.28905 0 7.90372V4.09973C0.000636562 3.71404 0.102505 3.33527 0.29542 3.00131C0.488335 2.66734 0.765535 2.38987 1.0993 2.19665L4.40043 0.293584C4.73497 0.10123 5.11411 0 5.5 0C5.88589 0 6.26503 0.10123 6.59957 0.293584Z" fill="white"/>
        </svg>
    );
};

export default Choose;